module.exports = __webpack_public_path__ + "static/media/11d.03433398.png";